/**
 * currentCampusStore — the campus the user is currently scoped to.
 *
 * PROJECT_STATE task P2 #11 — "Currently viewing campus" chip in the
 * sidebar. The supervisor on ABC operates across 2 campuses (SMT,
 * HC #1) and disorients when navigating between dashboard / board /
 * bulk-create with each surface holding an independent filter. This
 * store gives the chip a single read-source that pages can publish
 * to from their own filter widgets.
 *
 * UI state only (CLAUDE.md Section 3). The actual filter behavior of
 * each page still lives in that page's URL params or local state;
 * this store is only the *display label* in the sidebar.
 */

import { create } from 'zustand'

interface CurrentCampusState {
  /** Active campus UUID, or null when the user is viewing all campuses. */
  campusId:   string | null
  /** Human-readable campus name for chip rendering. */
  campusName: string | null
  /** Publish the active campus from the page's filter widget. Pass null/null to clear. */
  setCurrentCampus: (campusId: string | null, campusName: string | null) => void
  /** Convenience for unmount / no-campus-selected paths. */
  clear: () => void
}

export const useCurrentCampusStore = create<CurrentCampusState>((set) => ({
  campusId:   null,
  campusName: null,
  setCurrentCampus: (campusId, campusName) => set({
    campusId:   campusId   && campusId.length   > 0 ? campusId   : null,
    campusName: campusName && campusName.length > 0 ? campusName : null,
  }),
  clear: () => set({ campusId: null, campusName: null }),
}))
